<template>
  <div>
    <b-button @click="showModal = !showModal" size="sm" variant="link">
      toggle columns
    </b-button>
    <b-modal
      v-model="showModal"
      button-size="sm"
      title="Field settings"
      @ok="submit()"
    >
      <slot name="top" />
      <div class="toggle-fields-modal">
        <b-form-checkbox-group
          v-model="selected"
          text-field="name"
          value-field="key"
          :options="fields"
          switches
          class="d-flex flex-wrap"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import isEqual from 'js-isequal';
import cloneDeep from 'clone';

export default {
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    namespace: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showModal: false,
      selected: [],
      newFields: this.fields
    };
  },

  computed: {
    uniqNamespace() {
      return `${this.$store.state.app.role}-${this.namespace}`;
    }
  },

  methods: {
    saveState() {
      return JSON.stringify(
        localStorage.setItem(this.uniqNamespace, JSON.stringify(this.selected))
      );
    },
    getState() {
      return JSON.parse(localStorage.getItem(this.uniqNamespace));
    },
    submit() {
      this.saveState();
      this.$emit(
        'columns-toggled',
        this.fields.filter(el => {
          return this.selected.includes(el.key);
        })
      );
    }
  },

  created() {
    if (this.fields.length === 0) return;
    if (!this.getState()) {
      this.selected = this.fields.map(el => el.key);
    } else {
      this.selected = this.getState();
    }
    this.submit();
  },

  watch: {
    fields(val) {
      if (this.fields.length === 0) return;
      if (!this.getState()) {
        this.selected = this.fields.map(el => el.key);
      } else {
        this.selected = this.getState();
      }
      if (!isEqual(val, this.newFields)) {
        this.submit();
        this.newFields = cloneDeep(this.fields);
      }
    }
  }
};
</script>

<style lang="scss">
.toggle-fields-modal {
  .custom-switch {
    margin-right: 0;
    padding-right: 1rem;
    width: 50%;
  }
}
</style>
